import { computed, onMounted, onUnmounted, ref, type ComputedRef } from 'vue';

import { appStorageController, ProjectSettings, pwaService } from '@/shared/lib';

type PwaInstallBannerState = {
  isVisible: ComputedRef<boolean>;
  dismiss: () => void;
};

const usePwaInstallBanner = (): PwaInstallBannerState => {
  const isDismissed = appStorageController.pwaInstallBannerDismissed;
  const isDelayElapsed = ref<boolean>(false);

  let delayTimer: number | null = null;

  const isVisible: ComputedRef<boolean> = computed<boolean>(
    () => isDelayElapsed.value && pwaService.isInstallActionVisible.value && !isDismissed.value,
  );

  onMounted(() => {
    delayTimer = window.setTimeout(() => {
      isDelayElapsed.value = true;
    }, ProjectSettings.pwa.installBannerDelay);
  });

  onUnmounted(() => {
    if (delayTimer !== null) {
      window.clearTimeout(delayTimer);
    }
  });

  const dismiss = (): void => {
    appStorageController.setPwaInstallBannerDismissed(true);
  };

  return { isVisible, dismiss };
};

export { usePwaInstallBanner };
